module.exports = __webpack_public_path__ + "494cd07c/img/at-icon.5d6fc5d8.svg";